import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {routing} from './inventory.routing';
import {LayoutModule} from '../layout/layout.module';
import {InventoryComponent} from './inventory.component';
import {SharedTranslationModule} from '../shared/change-language/shared-translation.module';

@NgModule({
  imports: [
    CommonModule, routing, LayoutModule, SharedTranslationModule
  ],
    declarations: [InventoryComponent]
})
export class InventoryModule {
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/inventory/inventory.module.ts